import React from "react";
import {FormattedMessage} from "react-intl";
import {OptionGroup} from "@/data/entities/option";

type Props = {
    group: Pick<OptionGroup, "type" | "maxOptions">,
};

/**
 * E.g. "Verplicht · kies 1" or "Optioneel · max. 2".
 */
const OptionGroupTypeLabel = ({group}: Props) => (
    group.type === "required"
        ? <FormattedMessage id={"optionGroupType.required"}/>
        : group.maxOptions === 0
            ? <FormattedMessage id={"optionGroupType.optionalUnlimited"}/>
            : <FormattedMessage id={"optionGroupType.optional"} values={{max: group.maxOptions}}/>
);

export default OptionGroupTypeLabel;